import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const FLAG_DETAILS_REDUCER_NAME = "flag-details";

const initialState = {
  flagData: {
    files: [],
    flagDetails: {},
    flaggedData: {},
    resolutionStatusHistory: [],
    reviewStatusHistory: [],
  },
  flaggedDataColumns: [],
};

const flagDetailsSlice = createSlice({
  name: FLAG_DETAILS_REDUCER_NAME,
  initialState: initialState,
  reducers: {
    setFlagData: (state, { payload }) => {
      state.flagData = { ...payload };
    },
    setFlaggedDataColumns: (state, { payload }) => {
      state.flaggedDataColumns = [...payload];
    },
    updateResolutionStatusHistoryRow: (state, { payload }) => {
      const currentRSH = [...state.flagData.resolutionStatusHistory];

      const updatedRSH = currentRSH.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item,
      );

      state.flagData.resolutionStatusHistory = updatedRSH;
    },
    updateRelatedDocuments: (state, { payload }) => {
      const tempFiles = [...state.flagData.files];
      state.flagData.files = [...tempFiles, payload];
    },
    updateFlagDetails: (state, { payload }) => {
      const tempDetails = { ...state?.flagData?.flagDetails };
      state.flagData.flagDetails = { ...tempDetails, ...payload };
    },
  },
});

export const {
  setFlagData,
  setFlaggedDataColumns,
  updateResolutionStatusHistoryRow,
  updateRelatedDocuments,
  updateFlagDetails,
} = flagDetailsSlice.actions;

export default flagDetailsSlice.reducer;

export const useSelectFlagData = () => {
  return useSelector((state) => state[FLAG_DETAILS_REDUCER_NAME].flagData);
};

export const useSelectFlaggedDataColumns = () => {
  return useSelector(
    (state) => state[FLAG_DETAILS_REDUCER_NAME].flaggedDataColumns,
  );
};
